export type PlanDetailGroup = {
  id: string;
  caption: string;
  planDetailRows: Array<PlanDetailRow>;
};

export type PlanDetailRow = {
  label: string;
  tooltip: string;
  isOnPlanComparison: boolean;
  planEntries: Array<PlanDetailEntry>;
};

export type PlanDetailEntry = {
  id: string;
  value: string;
};
